import type React from 'react';

import ComponentPortals from '../../molecules/ComponentPortals';

interface StickyBottomProps {
    className?: string;
    children: React.ReactNode;
}

const StickyBottom = (props: React.PropsWithChildren<StickyBottomProps>) => {
    return <ComponentPortals cmpName="StickyBottom">{props.children}</ComponentPortals>;
};

export default StickyBottom;
